export const LAYOUT_LIGHT = 'LAYOUT:LIGHT';
export const LAYOUT_DARK = 'LAYOUT:DARK';
export const LAYOUT_FOLD_NAV = 'LAYOUT:FOLD_NAV';
export const LAYOUT_UNFOLD_NAV = 'LAYOUT:UNFOLD_NAV';